import { Component, Input } from '@angular/core';

import { ActivityEventNames, SearchActivityEvents } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-contact-logged-event',
  templateUrl: './contact-logged-event.component.html'
})

export class ASContactLoggedEventComponent extends WithDisposableSubject()  {

  @Input() item: SearchActivityEvents.Node;

  /**
   *
   */
  constructor(
  ) {
    super();
  }

  isPhone() {
    return this.item?.payload['phoneNumber'] === undefined ? false : true;
  }

  isEmail() {
    return this.item?.payload['email'] === undefined ? false : true;
  }

  getContactType() {
    if (this.isPhone()) {
      return 'Phone';
    }
    if (this.isEmail()) {
      return 'Email';
    }
    return 'In Person';
  }

  // For now we only have one type of canvass result of this type
  canvassSubResult() {
    if (this.item.name === ActivityEventNames.CreateContactAttemptCustomFormContacted) {
      return 'contacted';
    }

    return 'contacted';
  }

  getHomeWorkMobile() {
    const type = this.item.payload?.phoneNumber?.type || this.item.payload?.email?.type;
    if (type.includes('home')) {
      return 'Home';
    }
    if (type.includes('cell')) {
      return 'Mobile';
    }
    if (type.includes('work')) {
      return 'Work';
    }
    return '';
  }

  getStatus() {
    return (this.item.payload.email || this.item.payload.phoneNumber)?.status;
  }

  getSubscribed() {
    return (this.item.payload.email || this.item.payload.phoneNumber)?.subscribed;
  }

}
